module.exports = __webpack_public_path__ + "assets/images/4b87834c045496ba160353d60d9c7bdd.png";